import { Eye } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Subtle 12px line that reassures the user the AI already knows their
 * company context. Renders nothing when the profile has neither company
 * nor industry set.
 *
 * Use anywhere inside an assistant chat header.
 */
export default function AISeesIndicator({ className = "", testId = "ai-sees-indicator" }) {
  const { user } = useAuth();
  // Regression repair 2026-10-03 · Issue 4 (AI context merge).
  // Both fields MUST come from the same source. The Settings company
  // profile sub-doc is the authoritative display identity for AI
  // contextual labels. Only fall back to signup-time top-level fields
  // when the profile sub-doc hasn't been filled in yet.
  const profile = user?.company_profile || {};
  const company = (
    profile.company_name
    || profile.name
    || user?.company
    || ""
  ).trim();
  const industry = (
    profile.industry
    || user?.company_industry
    || user?.industry
    || ""
  ).trim();
  if (!company && !industry) return null;
  const parts = [company, industry].filter(Boolean).join(" · ");
  return (
    <p
      data-testid={testId}
      className={`text-[12px] text-[#888] flex items-center gap-1.5 ${className}`}
      title="The AI already knows your business — pulled from your profile."
    >
      <Eye size={11} className="text-[#bbb]" />
      <span>AI sees: <span className="text-[#555] font-medium">{parts}</span></span>
    </p>
  );
}
